import axios from "axios";
// 13.203.37.142
// export const BASE_URL =
//    process.env.NODE_ENV === "development"
//       ? "http://localhost:8000/api"
//       : "https://webideasolution.in/eisakutms/public/api";

// export const BASE_URL_IMAGE =
//    process.env.NODE_ENV === "development"
//       ? "http://localhost:8000/"
//       : "https://webideasolution.in/eisakutms/public/";

export const BASE_URL = 'https://staging.v1.eisakutms.com/api/';

export const BASE_URL_IMAGE = 'https://staging.v1.eisakutms.com/';


const client = axios.create({
   baseURL: BASE_URL,
   // timeout: 60000, // 15 seconds timeout
   // timeoutErrorMessage: "Request timed out. Please try again.",
});

client.interceptors.request.use(async (config) => {
   const token = JSON.parse(localStorage.getItem("token"));
   if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
   }
   return config;
});

export default client;
